var _path, _rect, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _rect2, _path15, _path16, _rect3, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _line, _path26, _line2, _path27, _path28, _path29, _path30;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUiux(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 400 300",
    width: 406,
    height: 306,
    className: "illustration styles_illustrationTablet__1DWOa",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "_003",
    "data-name": 3
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M356.5,231.33H43.5a.46.46,0,0,1-.46-.46.47.47,0,0,1,.46-.46h313a.47.47,0,0,1,.46.46A.46.46,0,0,1,356.5,231.33Z",
    fill: "#d1d3d4"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 66.93,
    y: 44.49,
    width: 272.15,
    height: 166.33,
    rx: 5.37,
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M333.7,211.32H72.3a5.88,5.88,0,0,1-5.87-5.88V49.86A5.87,5.87,0,0,1,72.3,44H333.7a5.87,5.87,0,0,1,5.87,5.87V205.44A5.88,5.88,0,0,1,333.7,211.32ZM72.3,45a4.87,4.87,0,0,0-4.87,4.87V205.44a4.88,4.88,0,0,0,4.87,4.88H333.7a4.88,4.88,0,0,0,4.87-4.88V49.86A4.87,4.87,0,0,0,333.7,45Z",
    fill: "#231f20"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M187.75,163.67H82.63a.46.46,0,0,1-.46-.46.47.47,0,0,1,.46-.46H187.75a.47.47,0,0,1,.46.46A.46.46,0,0,1,187.75,163.67Z",
    fill: "#d1d3d4"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M 133.395 162.54 C 133.035 162.54 132.744 162.746 132.744 163 L 132.744 201.88 C 132.744 202.134 133.035 202.34 133.395 202.34 C 133.751 202.335 134.038 202.132 134.046 201.88 L 134.046 163.02 C 134.053 162.76 133.762 162.545 133.395 162.54 Z",
    fill: "#d1d3d4",
    style: {
      transformBox: "fill-box",
      transformOrigin: "50% 50%"
    },
    transform: "matrix(-1, 0, 0, -1, 0.000003, -0.000002)"
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M320.64,137.77H199.76a.46.46,0,0,1-.46-.46.45.45,0,0,1,.46-.46H320.64a.45.45,0,0,1,.46.46A.46.46,0,0,1,320.64,137.77Z",
    fill: "#d1d3d4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M320.64,149.59H199.76a.45.45,0,0,1-.46-.46.46.46,0,0,1,.46-.46H320.64a.46.46,0,0,1,.46.46A.45.45,0,0,1,320.64,149.59Z",
    fill: "#d1d3d4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M320.64,161.42H199.76a.46.46,0,0,1,0-.92H320.64a.46.46,0,1,1,0,.92Z",
    fill: "#d1d3d4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M320.64,173.25H199.76a.47.47,0,0,1,0-.93H320.64a.47.47,0,0,1,0,.93Z",
    fill: "#d1d3d4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M320.64,185.07H199.76a.46.46,0,0,1,0-.92H320.64a.46.46,0,1,1,0,.92Z",
    fill: "#d1d3d4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M326.84,121.81H187.18a.46.46,0,0,1-.46-.46.47.47,0,0,1,.46-.46H326.84a.47.47,0,0,1,.46.46A.46.46,0,0,1,326.84,121.81Z",
    fill: "#d1d3d4"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 199.38,
    y: 77.99,
    width: 48.05,
    height: 32.66,
    rx: 2.08,
    style: {
      fill: "rgb(0, 83, 74)"
    }
  }), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M187.56,201.4a.45.45,0,0,1-.46-.46V68.56a.46.46,0,0,1,.46-.46.47.47,0,0,1,.46.46V200.94A.46.46,0,0,1,187.56,201.4Z",
    fill: "#d1d3d4"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M327.77,68.69h-250a.46.46,0,0,1-.46-.46.47.47,0,0,1,.46-.46h250a.47.47,0,0,1,.47.46A.46.46,0,0,1,327.77,68.69Z",
    fill: "#d1d3d4"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M322.62,202.68H83.38a5.88,5.88,0,0,1-5.88-5.87V58.5a5.89,5.89,0,0,1,5.88-5.88H322.62a5.89,5.89,0,0,1,5.88,5.88V196.81A5.88,5.88,0,0,1,322.62,202.68ZM83.38,53.62A4.89,4.89,0,0,0,78.5,58.5V196.81a4.88,4.88,0,0,0,4.88,4.87H322.62a4.88,4.88,0,0,0,4.88-4.87V58.5a4.89,4.89,0,0,0-4.88-4.88Z",
    fill: "#231f20"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M230.7,210.87,202,210.8l-28.69.07s-2.53,26-19,37.13h95.41C233.23,236.9,230.7,210.87,230.7,210.87Z",
    fill: "#fff"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M249.71,248.5H154.29a.49.49,0,0,1-.47-.35.48.48,0,0,1,.2-.56c16.09-10.84,18.76-36.51,18.79-36.77a.5.5,0,0,1,.5-.45L202,210.3l28.7.07a.51.51,0,0,1,.5.45c0,.26,2.7,25.93,18.79,36.77a.51.51,0,0,1,.2.56A.5.5,0,0,1,249.71,248.5Zm-93.85-1h92.29c-14.2-10.69-17.47-32.71-17.89-36.13L202,211.3l-28.25.07C173.32,214.79,170.06,236.81,155.86,247.5Z",
    fill: "#231f20"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 142.21,
    y: 248,
    width: 119.59,
    height: 9.9,
    rx: 4.86,
    fill: "#fff"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M256.94,258.41H147.07a5.37,5.37,0,0,1-5.36-5.36v-.19a5.37,5.37,0,0,1,5.36-5.36H256.94a5.37,5.37,0,0,1,5.36,5.36v.19A5.37,5.37,0,0,1,256.94,258.41ZM147.07,248.5a4.37,4.37,0,0,0-4.36,4.36v.19a4.37,4.37,0,0,0,4.36,4.36H256.94a4.37,4.37,0,0,0,4.36-4.36v-.19a4.37,4.37,0,0,0-4.36-4.36Z",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 93.67,
    cy: 61.38,
    r: 3.13,
    style: {
      fill: "rgb(0, 83, 74)"
    }
  }), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M95.17,128.84a4.63,4.63,0,0,1,.09,5.79l.29,0",
    fill: "#fff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 95.77,
    y: 96.18,
    width: 73.19,
    height: 34.73,
    rx: 3.34,
    fill: "#fff"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M165.62,131.41H99.11a3.84,3.84,0,0,1-3.84-3.84v-28a3.84,3.84,0,0,1,3.84-3.84h66.51a3.84,3.84,0,0,1,3.84,3.84v28.05A3.84,3.84,0,0,1,165.62,131.41ZM99.11,96.68a2.84,2.84,0,0,0-2.84,2.84v28.05a2.84,2.84,0,0,0,2.84,2.84h66.51a2.84,2.84,0,0,0,2.84-2.84v-28a2.84,2.84,0,0,0-2.84-2.84Z",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 112.64,
    cy: 113.55,
    r: 9.29,
    style: {
      fill: "rgb(0, 83, 74)"
    }
  }), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M160.94,109.12H131.43a.5.5,0,0,1,0-1h29.51a.5.5,0,0,1,0,1Z",
    fill: "#231f20"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M160.94,114.05H131.43a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h29.51a.5.5,0,0,1,.5.5A.5.5,0,0,1,160.94,114.05Z",
    fill: "#231f20"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M150.69,119H131.43a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h19.26a.5.5,0,0,1,.5.5A.5.5,0,0,1,150.69,119Z",
    fill: "#231f20"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M72.8,114.93a3.32,3.32,0,0,0-2.34-2.52,2,2,0,0,0-1.59.18,2.14,2.14,0,0,0-.72,2,4.53,4.53,0,0,0,1.45,3,4.48,4.48,0,0,0,3.1,1.18",
    fill: "#fff"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M86.49,111.29s3.86,4.4,2.91,5.35-3.18.48-3.18.48",
    fill: "#fff"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M295,171.16l-33.52.57a3.15,3.15,0,0,1-2.93-1.75h0c-.36-1,.37-1.84,1.62-1.87l33.52-.57a3.13,3.13,0,0,1,2.93,1.75h0C297,170.29,296.28,171.13,295,171.16Z",
    fill: "#fff"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M294.85,87.35a7,7,0,0,0,1.94.85,2.69,2.69,0,0,0,2.69-.47,3.49,3.49,0,0,0,.57-1.08",
    fill: "#fff"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M294.8,78.32s-3.86,4.4-2.92,5.35,3.19.47,3.19.47",
    fill: "#fff"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 183.24,
    y1: 166.22,
    x2: 144.57,
    y2: 197.94,
    fill: "#fff"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M144.57,198.4a.46.46,0,0,1-.35-.17.46.46,0,0,1,.06-.65L183,165.86a.47.47,0,0,1,.65.06.46.46,0,0,1-.07.65l-38.66,31.72A.48.48,0,0,1,144.57,198.4Z",
    fill: "#d1d3d4"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 144.57,
    y1: 166.22,
    x2: 183.24,
    y2: 197.94,
    fill: "#fff"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M183.24,198.4a.46.46,0,0,1-.29-.11l-38.67-31.72a.46.46,0,0,1-.06-.65.47.47,0,0,1,.65-.06l38.66,31.72a.46.46,0,0,1,.07.65A.48.48,0,0,1,183.24,198.4Z",
    fill: "#d1d3d4"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M301,155.1a.49.49,0,0,1-.24-.93c.06,0,5.27-2.81,6.59-5.32a.49.49,0,0,1,.67-.2.49.49,0,0,1,.21.67c-1.46,2.78-6.78,5.61-7,5.73A.64.64,0,0,1,301,155.1Z",
    fill: "#fff"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M 84.341 197.432 C 84.205 197.43 84.077 197.368 83.991 197.262 C 83.827 197.066 83.854 196.774 84.051 196.612 L 122.771 164.892 C 122.969 164.734 123.256 164.76 123.421 164.952 C 123.583 165.15 123.551 165.442 123.351 165.602 L 84.691 197.322 C 84.594 197.403 84.468 197.443 84.341 197.432 Z",
    fill: "#d1d3d4"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M 123.381 198.543 C 123.275 198.541 123.172 198.502 123.091 198.433 L 84.421 166.713 C 84.224 166.55 84.197 166.259 84.361 166.063 C 84.526 165.871 84.814 165.845 85.011 166.003 L 123.671 197.723 C 123.871 197.882 123.903 198.174 123.741 198.373 C 123.651 198.479 123.52 198.541 123.381 198.543 Z",
    fill: "#d1d3d4"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 261.16,
    y: 78.114,
    width: 48.05,
    height: 32.66,
    rx: 2.08,
    style: {
      fill: "rgb(0, 83, 74)"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUiux);
export default __webpack_public_path__ + "static/media/uiux.6cc81db1f36f881935e81ac67cfd5650.svg";
export { ForwardRef as ReactComponent };